// extracted by mini-css-extract-plugin
module.exports = {"ManageContent":"ManageContent_ManageContent__grAL1"};